import { useState, useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Article from '../components/article/Article'
import SubHeading from '../components/subHeading/SubHeading'
import NewsletterCTA from '../components/NewsletterCTA'
import articlesData from '../mocks/articles.json'
import { getArchivedArticles, getArticlesByCategory, getUniqueCategories, sortArticles } from '../utilities/articles'

import './articles.css'

const Articles = () => {
  const location = useLocation()
  const history = useHistory()
  const allArticles = useMemo(() => articlesData.Articles, [])
  const categories = useMemo(() => getUniqueCategories(allArticles), [allArticles])
  const [selectedCategory, setSelectedCategory] = useState('Todos')
  const [sortBy, setSortBy] = useState('date-desc')

  // Leer el parámetro de query al cargar
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const categoryParam = searchParams.get('category')
    if (categoryParam && categories.includes(categoryParam)) {
      setSelectedCategory(categoryParam)
      return
    }
    setSelectedCategory('Todos')
  }, [location.search, categories])

  const handleCategoryChange = (category) => {
    setSelectedCategory(category)

    if (category === 'Todos') {
      history.replace('/articulos')
      return
    }

    history.replace(`/articulos?category=${encodeURIComponent(category)}`)
  }
  
  const filteredArticles = getArticlesByCategory(allArticles, selectedCategory)
  const sortedArticles = sortArticles(filteredArticles, sortBy)

  return (
    <section
      className='articles-page section__padding'
      aria-labelledby='articles-page-title'
    >
      <div className='articles-page__hero'>
        <p className='articles-page__eyebrow'>Divulgación</p>
        <div id='articles-page-title' className='articles-page__heading'>
          <SubHeading title='Artículos' color={true} />
        </div>
        <div className='articles-page__divider' aria-hidden='true'></div>
        <p className='articles-page__intro'>
          Aquí puedes consultar el archivo de artículos publicados por Carolina Ackermann y La Vida en Rojo, así como voces y colaboraciones en las que hemos participado.
          Algunos textos han sido recuperados en formato PDF debido a que los medios originales ya no se encuentran disponibles.
          Los tres más recientes están destacados en la página de inicio. 
        </p>
      </div>

      <div className='articles-page__controls'>
        <div className='articles-page__filters'>
          <button
            className={`articles-page__filter-btn ${selectedCategory === 'Todos' ? 'articles-page__filter-btn--active' : ''}`}
            onClick={() => handleCategoryChange('Todos')}
          >
            Todos
          </button>
          {categories.map((category) => (
            <button
              key={category}
              className={`articles-page__filter-btn ${selectedCategory === category ? 'articles-page__filter-btn--active' : ''}`}
              onClick={() => handleCategoryChange(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <div className='articles-page__sort'>
          <label htmlFor='sort-select' className='articles-page__sort-label'>
            Ordenar por:
          </label>
          <select
            id='sort-select'
            className='articles-page__sort-select'
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value='date-desc'>Fecha (Más recientes)</option>
            <option value='date-asc'>Fecha (Más antiguos)</option>
            <option value='name-asc'>Nombre (A - Z)</option>
            <option value='name-desc'>Nombre (Z - A)</option>
          </select>
        </div>
      </div>

      <div className='articles-page__grid'>
        {sortedArticles.map((article) => (
          <Article
            key={article.id}
            imgUrl={article.imgUrl}
            title={article.title}
            url={article.url}
            date={article.date}
            category={article.category}
            fromCategory={selectedCategory}
          />
        ))}
      </div>
      <NewsletterCTA />
    </section>
  )
}

export default Articles
